<template>
  <span
    class="text"
    :class="[`text--${color}`]"
    :aria-label="ariaLabel">
    {{ text }}
  </span>
</template>

<script setup>
  // Props with validation
  defineProps({
    text: {
      type: String,
      required: true,
      validator: value => typeof value === 'string' && value.trim().length > 0
    },
    color: {
      type: String,
      default: 'black',
      validator: value => [ 'black', 'red' ].includes(value)
    },
    ariaLabel: {
      type: String,
      default: null
    }
  })
</script>

<style lang="scss" scoped>
.text {
  // Base typography styles
  font-size: var(--typography-size-m, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: 0.4px;

  // text-align: center;

  // Display and layout
  display: inline-block;
  word-wrap: break-word;

  // Color variants
  &--black {
    color: var(--color-black);
  }

  &--red {
    color: var(--color-red);
  }

  // Responsive design
  @include mq($until: tablet) {
    font-size: var(--typography-size-ui-kit-18, 18px);
    letter-spacing: 0.3px;
  }

  @include mq($until: mobile) {
    font-size: var(--typography-size-ui-kit-16, 16px);
    letter-spacing: 0.2px;
  }
}
</style>
